export default {
      id: "logo-canara-hsbc-usage",
      viewBox: "0 0 88 27",
      url: __webpack_public_path__ + "sprite.svg#logo-canara-hsbc",
      toString: function () {
        return this.url;
      }
    }